/**
 * Mirrors the backend algorithms.py constants used to compute listing_premium_factor.
 * Kept in sync manually — these values change very rarely.
 */

export const TYPICAL_LISTING_CONFIG_BY_BEDROOMS: Record<string, { bathrooms: number; accommodates_upper_limit: number }> = {
  '0': { bathrooms: 1, accommodates_upper_limit: 3 },
  '1': { bathrooms: 1, accommodates_upper_limit: 4 },
  '2': { bathrooms: 1.5, accommodates_upper_limit: 7 },
  '3': { bathrooms: 2, accommodates_upper_limit: 10 },
  '4': { bathrooms: 2.5, accommodates_upper_limit: 13 },
  '5': { bathrooms: 3, accommodates_upper_limit: 16 },
  '6': { bathrooms: 3.5, accommodates_upper_limit: 16 },
};

export const PREMIUM_FACTOR_WEIGHTS = {
  bathrooms: { 0.5: 0.2, 1: 0.3, 1.5: 0.4 } as Record<number, number>,
  accommodates: { 1: 0.2, 2: 0.3, 3: 0.4 } as Record<number, number>,
  has_pool: 0.2,
};

export function computeListingPremiumBreakdown(
  bedrooms: number,
  bathrooms: number,
  accommodates: number,
  hasPool: boolean,
) {
  const bedroomKey = String(bedrooms >= 6 ? 6 : bedrooms);
  const typical = TYPICAL_LISTING_CONFIG_BY_BEDROOMS[bedroomKey] ?? TYPICAL_LISTING_CONFIG_BY_BEDROOMS['1'];

  let bathroomFactor = 0;
  const bathroomDiff = bathrooms - typical.bathrooms;
  for (const [diff, weight] of Object.entries(PREMIUM_FACTOR_WEIGHTS.bathrooms)) {
    if (bathroomDiff >= Number(diff)) bathroomFactor = weight;
  }

  let accommodatesFactor = 0;
  const accommodatesDiff = accommodates - typical.accommodates_upper_limit;
  for (const [diff, weight] of Object.entries(PREMIUM_FACTOR_WEIGHTS.accommodates)) {
    if (accommodatesDiff >= Number(diff)) accommodatesFactor = weight;
  }

  const poolFactor = hasPool ? PREMIUM_FACTOR_WEIGHTS.has_pool : 0;

  const totalPremium = Math.round((bathroomFactor + accommodatesFactor + poolFactor) * 10) / 10;

  return {
    typical,
    bathroomFactor,
    accommodatesFactor,
    poolFactor,
    totalPremium,
  };
}
